import { render, staticRenderFns } from "./branchAdd.vue?vue&type=template&id=79bc8b35&scoped=true&"
import script from "./branchAdd.vue?vue&type=script&lang=js&"
export * from "./branchAdd.vue?vue&type=script&lang=js&"
import style0 from "./branchAdd.vue?vue&type=style&index=0&id=79bc8b35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bc8b35",
  null
  
)

export default component.exports